import { render, staticRenderFns } from "./GeneralAlertModal.vue?vue&type=template&id=60678e36"
import script from "./GeneralAlertModal.vue?vue&type=script&lang=js"
export * from "./GeneralAlertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports